import React from 'react';

import * as S from './styles';

import { ModuleEnum } from '@/main/services/enum/ModuleEnum';
import { MenuItemResponse } from '@/main/models/response/menu';
import { useStyles } from './styles';
import { useTheme } from '@mui/material/styles';
import { getActionColors } from '@/main/style/styleMaterialUIGlobal';

import { homeIconSvg } from './svg/homeIconSVG';
import { registrationIconSvg } from './svg/registrationIconSVG';

import { orderIcon } from './icon/orderIcon';
import { quotationIcon } from './icon/quotationIcon';
import { inventoryIcon } from './icon/inventoryIcon';
import { linkIcon } from './icon/linkIcon';
import { integrationIcon } from './icon/integrationIcon';
import { reportIcon } from './icon/reportIcon';
import { claimIcon } from './icon/claimIcon';
import { quotationIconSVG } from './svg/quotationIconSVG';

interface IRoute {
  idModule: number;
  name: string;
  route?: string;
  screens: MenuItemResponse[];
  sort: number;
}

interface IDrawerMenuIconComponentProps {
  route: IRoute;
  idModule: number;
  itemSelected?: string;
}

export default function DrawerMenuIconComponent(props: IDrawerMenuIconComponentProps) {
  const classes = useStyles();
  const theme = useTheme();
  const actionColors = getActionColors(theme);
  const hasRoute =
    props.route.screens !== undefined && props.route.screens.length > 0
      ? props.route.screens.find(screen => screen.route === props.itemSelected)
      : props.route;

  const selectThisItem = hasRoute?.route === props.itemSelected;

  function renderIconMenu(idModule: number) {
    switch (idModule) {
      case ModuleEnum.Home:
        return homeIconSvg(
          selectThisItem,
          actionColors.focus,
          actionColors.disabled
        );
      case ModuleEnum.Registration:
        return registrationIconSvg(
          selectThisItem,
          actionColors.focus,
          actionColors.disabled
        );
      case ModuleEnum.Order:
        return (
          <S.ContainerOrderIcon>
            {orderIcon(
              selectThisItem,
              actionColors.focus,
              actionColors.disabled
            )}
          </S.ContainerOrderIcon>
        );
      case ModuleEnum.Quotation:
        return quotationIconSVG(
          selectThisItem,
          actionColors.focus,
          actionColors.disabled
        );
      case ModuleEnum.Inventory:
        return inventoryIcon(
          selectThisItem,
          actionColors.focus,
          actionColors.disabled
        )
      case ModuleEnum.Integration:
        return integrationIcon(
          selectThisItem,
          actionColors.focus,
          actionColors.disabled
        )
      case ModuleEnum.Report:
        return reportIcon(
          selectThisItem,
          actionColors.focus,
          actionColors.disabled
        )
      case ModuleEnum.Claim:
        return claimIcon(
          selectThisItem,
          actionColors.focus,
          actionColors.disabled
        )
      default:
        return linkIcon(
          selectThisItem,
          actionColors.focus,
          actionColors.disabled
        );
    }
  }

  return renderIconMenu(props.idModule);
}
